interface Props {
  total: number
  due: number
  mastered: number
  newCount: number
}

export default function Dashboard({ total, due, mastered, newCount }: Props) {
  const pct = total > 0 ? Math.round((mastered / total) * 100) : 0

  return (
    <div className="w-full max-w-md mx-auto px-4 sm:px-5">
      <div className="flex items-center justify-between text-xs text-zinc-500 mb-1.5">
        <span>学习进度</span>
        <span>{pct}% 掌握</span>
      </div>

      {/* 进度条 */}
      <div className="w-full h-1.5 rounded-full bg-white/5 overflow-hidden flex">
        <div
          className="h-full bg-emerald-500/70 transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>

      {/* 三项统计 */}
      <div className="flex justify-between mt-3 text-center">
        <div className="flex-1">
          <div className="text-lg font-bold text-amber-400">{due}</div>
          <div className="text-[10px] text-zinc-500">待复习</div>
        </div>
        <div className="flex-1">
          <div className="text-lg font-bold text-emerald-400">{mastered}</div>
          <div className="text-[10px] text-zinc-500">已掌握</div>
        </div>
        <div className="flex-1">
          <div className="text-lg font-bold text-sky-400">{newCount}</div>
          <div className="text-[10px] text-zinc-500">新卡片</div>
        </div>
      </div>
    </div>
  )
}
